import React from 'react'
import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';
import { useState, useEffect } from 'react';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import ProductRepository from 'src/repository/ProductRepository';
import Product from '@system/config/product';
import {
    load_all_selected_fields,
    remove_all_selected_fields,
    toggle_single_selected_fields
} from "src/store/slice/model/Order/OrderHistoryUI";
import { useDispatch, useSelector } from 'react-redux';
import ShowMoreLess from 'src/component/Product/ShowMoreLess';
import Helper from 'src/support/Helper';

const OrderDetailByLineItem = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_line_item_list, header_order_detail }, { fetch_order_list_by_line_item }, { order_download_single_invoice }] = useOrderStore();
    const orderNumber = System.getParams().order_number
    const [ascDesField, setAscDesField] = useState({});
    const [sortBy, setSortBy] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [lineItemList, setLineItemList] = useState({});
    const [isReorderable] = useReduxState(false, 'setIsReOrderable')
    const [checkAll, setCheckAll] = useState(false);
    let selected_fields = useSelector((state) => state.entities.model_OrderHistory__UI.selected_fields)
    const dispatch = useDispatch(false);

    useEffect(() => {
        async function fetchHere() {
            await getOrderListByLineItems()
        }

        fetchHere()
    }, []);

    useEffect(() => {
        async function fetchHere() {
            setTimeout(() => {
                setLineItemList(order_line_item_list[orderNumber])
            }, 1500);
        }
        fetchHere()
    }, [order_line_item_list]);

    const getOrderListByLineItems = async () => {
        await fetch_order_list_by_line_item({
            orderNumber: orderNumber
        })
    }

    const sortAttributes = (columnName) => {
        let Attributes = [...lineItemList]
        let AttributesSorted = []
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)
        setSortOrder(ascDesField[columnName])
        if (ascDesField[columnName] === 'ASC') {
            AttributesSorted = Attributes.sort((a, b) => (b[columnName] < a[columnName] ? -1 : 1));
        } else if (ascDesField[columnName] === 'DESC') {
            AttributesSorted = Attributes.sort((a, b) => (b[columnName] > a[columnName] ? -1 : 1));
        }

        setLineItemList(AttributesSorted)
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const downloadSingleInvoice = async (invoiceNumber) => {
        await order_download_single_invoice({ invoiceNumber: invoiceNumber })
    }

    const onToggleSelect = (values) => {
        if (checkAll) {
            setCheckAll(false);
        }

        let selectedField = { ...values }
        dispatch(toggle_single_selected_fields({ ...selectedField }))
    }

    const getFilterData = (list) => {
        let res = {}
        if (list && list.length > 0) {
            list.map((e) => {
                if (e.product && e.product.ItemNumber) {
                    res[e.uniqueNumber] = e
                }
            })
        }
        return res
    }

    const onCheckAll = (checked) => {
        if (checked) {
            if (lineItemList && Object.entries(lineItemList).length > 0) {
                const filterData = getFilterData(lineItemList)
                dispatch(load_all_selected_fields({ selected_fields: filterData }))
            }
        } else {
            dispatch(remove_all_selected_fields())
        }

    };

    const getStatusOfForFieldActivated = (selectedList) => {
        if (checkAll === false && selected_fields !== undefined && selected_fields !== null &&
            lineItemList !== undefined && lineItemList !== null &&
            lineItemList.length > 0 &&
            Object.entries(selected_fields).length > 0 &&
            Object.entries(selected_fields).length == lineItemList.filter(x => x.product && x.product.ItemNumber).length) {
            setCheckAll(true)
        }

        if (selected_fields && selected_fields[selectedList.uniqueNumber] !== undefined
        ) {
            return selected_fields[selectedList.uniqueNumber];
        }

        return false
    };

    const getManufacturerName = (selectedItem) => {
        if (selectedItem.product !== undefined &&
            selectedItem.product !== null &&
            selectedItem.product.ManufacturerName !== undefined) {
            return selectedItem.product.ManufacturerName;
        }
        if (selectedItem.manufacturerName !== undefined &&
            selectedItem.manufacturerName !== null &&
            selectedItem.manufacturerName.trim() !== '') {
            return selectedItem.manufacturerName
        }
        return '';
    }
    return (
        <>
            {__check(['ORDER_API_CALL']).render}
            <div id="tab2" className="tab-pane fade position-relative in active">
                <div className="table-responsive">
                    {
                        lineItemList && Object.entries(lineItemList).length > 0 &&
                        !__check(['ORDER_API_CALL']).status &&
                        <table className="bs5 table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th className="text-nowrap">
                                        {isReorderable === true &&
                                            <div className="form-check font-15 d-flex align-items-center ps-0">
                                                <input type="checkbox" checked={checkAll} className="form-check-input ps-0 ms-0"
                                                    onClick={(e) => {
                                                        setCheckAll(e.target.checked)
                                                        onCheckAll(e.target.checked)
                                                    }}
                                                />
                                                <label className="form-check-label mt-0" htmlFor="customCheck1"></label>
                                            </div>
                                        }
                                    </th>
                                    <th className="">

                                    </th>
                                    <th className="w80"><span>Line Item <br />Numbers</span></th>
                                    <th className={
                                        getOrderByClass('manufacturer')
                                    }
                                        onClick={() => {
                                            sortAttributes('manufacturer')
                                        }}><span>Manufacturer</span></th>
                                    <th className={
                                        getOrderByClass('manufacturerPartNumber')
                                    }
                                        onClick={() => {
                                            sortAttributes('manufacturerPartNumber')
                                        }}><span>Manufacturer <br /> Part Number</span></th>
                                    <th className={
                                        getOrderByClass('customerPartNumber')
                                    }
                                        onClick={() => {
                                            sortAttributes('customerPartNumber')
                                        }}><span>Customer Part Number</span></th>
                                    <th className={
                                        getOrderByClass('status')
                                    }
                                        onClick={() => {
                                            sortAttributes('status')
                                        }}><span>Order status</span></th>
                                    <th className={
                                        getOrderByClass('quantity')
                                    }
                                        onClick={() => {
                                            sortAttributes('quantity')
                                        }}><span>Ordered Quantity</span></th>
                                    <th className={
                                        getOrderByClass('deliveredQuantity')
                                    }
                                        onClick={() => {
                                            sortAttributes('deliveredQuantity')
                                        }}><span>Shipped Quantity</span></th>
                                    <th className={
                                        getOrderByClass('remainingQuantity')
                                    }
                                        onClick={() => {
                                            sortAttributes('remainingQuantity')
                                        }}><span>Remaining Quantity</span></th>
                                    <th className={
                                        getOrderByClass('deliveryDate')
                                    }
                                        onClick={() => {
                                            sortAttributes('deliveryDate')
                                        }}>Delivery Date</th>
                                    <th><span>currency</span></th>
                                    <th className={
                                        getOrderByClass('unitPrice')
                                    }
                                        onClick={() => {
                                            sortAttributes('unitPrice')
                                        }}><span>Unit Price</span></th>
                                    <th className={
                                        getOrderByClass('totalPrice')
                                    }
                                        onClick={() => {
                                            sortAttributes('totalPrice')
                                        }}><span>Total Price</span></th>
                                    <th className={
                                        getOrderByClass('orderDate')
                                    }
                                        onClick={() => {
                                            sortAttributes('orderDate')
                                        }}><span>Order Date</span></th>
                                    <th>Order Type</th>
                                    <th className={
                                        getOrderByClass('invoiceNumber')
                                    }
                                        onClick={() => {
                                            sortAttributes('invoiceNumber')
                                        }}><span>Invoice Number</span></th>
                                    <th className={
                                        getOrderByClass('carrier')
                                    }
                                        onClick={() => {
                                            sortAttributes('carrier')
                                        }}><span>Carrier</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {lineItemList.map((j, i) => (
                                    <tr className={"align-middle " + (isReorderable === true ? (j.product && j.product.ItemNumber) ? '' : 'd-none' : '')} key={i}>
                                        <td>
                                            {isReorderable === true && (j.product && j.product.ItemNumber) &&
                                                <div className="form-check d-flex align-items-center font-15 ps-0">
                                                    <input type="checkbox" className="form-check-input ms-0"
                                                        id="forCheckbox"
                                                        onChange={() => (onToggleSelect(j))}
                                                        checked={getStatusOfForFieldActivated(j)}
                                                    />
                                                    <label className="form-check-label" htmlFor="forCheckbox" />
                                                </div>
                                            }
                                        </td>
                                        <td>
                                            <div>
                                                <a href={void (0)} className="text-blue2 d-flex align-items-center"
                                                    onClick={() => System.popup('OrderHistoryEmailPopUp', {
                                                        singleOrder: header_order_detail,
                                                        singleProduct: j
                                                    })}>
                                                    <i className="fa fa-envelope font-16"></i>
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div>{j.lineItemNumber}</div>
                                        </td>
                                        <td>{getManufacturerName(j)}</td>
                                        <td>
                                            {
                                                j.product && j.product.ItemNumber ?
                                                    <a href={Product.getProductDetailPageRouteURLWithCustomParameter(j.product)
                                                        +
                                                        "?ERPPartNumber=" +
                                                        j.product.ERPPartNumber + '&ItemNumber=' + j.product.ItemNumber}
                                                        target="_blank"
                                                        className="text-blue2 d-block font-bold" >{j.manufacturerPartNumber}</a>
                                                    :
                                                    <div>{j.manufacturerPartNumber}</div>
                                            }
                                            {
                                                j.product &&
                                                <div className='text-black-stone'>
                                                    <ShowMoreLess single_product={j.product} />
                                                </div>
                                            }
                                        </td>
                                        <td><span className="text-nowrap">{j.customerPartNumber && j.customerPartNumber}</span></td>
                                        <td><span className="text-nowrap">{j.status && j.status}</span></td>
                                        <td><span className="text-nowrap">{j.quantity && j.quantity}</span></td>
                                        <td><span className="text-nowrap">{j.deliveredQuantity && j.deliveredQuantity}</span></td>
                                        <td><span className="text-nowrap">{j.remainingQuantity && j.remainingQuantity}</span></td>
                                        <td><span className="text-nowrap">{j.finalDeliveryDate && j.finalDeliveryDate}</span></td>
                                        <td><span className="text-nowrap">{j.currency && j.currency}</span></td>
                                        <td><span className="text-nowrap">{j.unitPrice && j.currency !== undefined && j.currency !== null && j.currency.trim() != '' ? Helper.getFormatNumber(j.unitPrice, j.currency) : j.unitPrice}</span></td>
                                        <td><span className="text-nowrap">{j.totalPrice && j.currency !== undefined && j.currency !== null && j.currency.trim() != '' ? Helper.getFormatNumber(j.totalPrice, j.currency) : j.totalPrice}</span></td>
                                        <td><span className="text-nowrap">{j.finalOrderDate ? j.finalOrderDate : '-'}</span></td>

                                        <td><span className="text-nowrap">{j.orderType && j.orderType}</span></td>
                                        <td><span className="text-nowrap">{j.invoiceNumber ? <a href={void (0)} aria-label="InvoiceGenerationlink"
                                            onClick={() => downloadSingleInvoice(j.invoiceNumber)}>{j.invoiceNumber} </a> : '-'}</span></td>
                                        <td><span className="text-nowrap">{j.carrier ? j.carrier : '-'}</span></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }

                </div>
            </div>
        </>
    )
}

export default OrderDetailByLineItem